export const CLASS_NAMES = {
	contentShell: 'mx-auto w-full max-w-[960px] px-4 pb-20 pt-[64px] sm:pt-11',
	title:
		'mb-7 text-2xl sm:text-[40px] font-normal leading-8 text-[var(--color-primary-900)]'
} as const;
